import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useLanguage } from '../context/LanguageContext';

const CartIcon = () => {
  const { t } = useLanguage();
  const { getTotalItems } = useCart();
  const [isHovered, setIsHovered] = useState(false);
  const totalItems = getTotalItems();

  return (
    <Link
      to="/cart"
      className="relative flex items-center justify-center w-12 h-12 bg-amber-600 hover:bg-amber-700 text-white rounded-full transition-all duration-300 transform hover:scale-110 shadow-lg hover:shadow-xl"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <i className="fas fa-shopping-basket text-lg"></i>
      
      {/* Cart Badge */}
      {totalItems > 0 && (
        <span className="absolute -top-1 -right-1 bg-stone-900 text-white text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center shadow-lg border-2 border-white">
          {totalItems > 99 ? '99+' : totalItems}
        </span>
      )}
      
      {/* Tooltip */}
      {isHovered && (
        <div className="absolute -top-12 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap z-50">
          {t('cartTooltip').replace('{count}', totalItems)}
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"></div>
        </div>
      )}
    </Link>
  );
};

export default CartIcon;
